"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var splide_1 = __importStar(require("@splidejs/splide"));
var constants_1 = require("../data/constants");
var SplideSlider = /** @class */ (function (_super) {
    __extends(SplideSlider, _super);
    function SplideSlider() {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        var main = document.querySelector('main');
        if (!main) {
            return _this;
        }
        splide_1.default.defaults = {
            type: 'loop',
            rewind: true,
            gap: '.5rem',
            pagination: false,
            snap: true,
            mediaQuery: 'min',
            breakpoints: {
                1024: {
                    gap: 0,
                },
            },
        };
        _this.setElement(main);
        (_a = _this.getChildElements("[".concat(constants_1.DATA_SLIDER, "]"))) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            if (element.getAttribute('data-slider') == '') {
                var splide = new splide_1.default(element);
                splide.mount();
            }
            else if (element.getAttribute('data-slider') == 'news') {
                var splide = new splide_1.default(element, {
                    type: 'slide',
                    rewind: false,
                    perPage: 1,
                    gap: '1rem',
                    drag: true,
                    arrows: false,
                    pagination: false,
                    snap: true,
                    mediaQuery: 'min',
                    breakpoints: {
                        768: {
                            perPage: 3,
                            drag: false
                        },
                        1024: {
                            gap: '1.5rem'
                        },
                        1280: {
                            gap: '2rem'
                        }
                    },
                });
                splide.mount();
            }
        });
        return _this;
    }
    SplideSlider.prototype.roundTranslate = function (element, event) {
        var ul = element === null || element === void 0 ? void 0 : element.querySelector(".".concat(splide_1.CLASS_LIST));
        if (!ul) {
            return;
        }
        var transform = window.getComputedStyle(ul).transform;
        var matrix = new WebKitCSSMatrix(transform);
        if (event !== 'ready') {
            ul.style.transform = "translateX(".concat(Math.floor(matrix.m41), "px");
            return;
        }
        setTimeout(function () {
            ul.style.transform = "translateX(".concat(Math.floor(matrix.m41), "px");
        }, 100);
    };
    return SplideSlider;
}(AbstractComponent_1.default));
exports.default = SplideSlider;
